var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", [_vm._v("Contacts")]),
      _vm._v(" "),
      _c("p", [_vm._v("Add, remove and edit associated employees.")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-default btn-create",
          staticStyle: { margin: "0px" },
          attrs: { type: "button" },
          on: { click: _vm.createContact }
        },
        [_vm._v("\n    Create new contact\n  ")]
      ),
      _vm._v(" "),
      _vm._l(_vm.contactList, function(contact, index) {
        return _c(
          "div",
          [
            _c("h5", { staticStyle: { display: "inline-block" } }, [
              _vm._v("Contact " + _vm._s(index + 1))
            ]),
            _vm._v(" "),
            _c("textInput", {
              attrs: {
                title: "Full name",
                keyChain: ["contacts", index, "name"],
                placeholder: "Forename Surname"
              }
            }),
            _vm._v(" "),
            _c("textInput", {
              attrs: {
                title: "Job role",
                keyChain: ["contacts", index, "title"],
                placeholder: "Title at your organization"
              }
            }),
            _vm._v(" "),
            _c("textInput", {
              attrs: {
                title: "Email",
                keyChain: ["contacts", index, "email"],
                placeholder: "email@example.com",
                type: "email"
              }
            }),
            _vm._v(" "),
            _c("textInput", {
              attrs: {
                title: "Phone number",
                keyChain: ["contacts", index, "phone_number"],
                placeholder: "(555) 555-5555",
                type: "tel"
              }
            }),
            _vm._v(" "),
            _c("textInput", {
              attrs: {
                title: "LinkedIn",
                keyChain: ["contacts", index, "linkedin"],
                placeholder: "https://www.linkedin.com/in/larskroijer/",
                type: "url"
              }
            }),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "btn-default btn-delete",
                  staticStyle: { float: "right" },
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.removeContact(index)
                    }
                  }
                },
                [_vm._v("\n        Remove contact\n      ")]
              )
            ]),
            _vm._v(" "),
            _c("br")
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47cbc33c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47cbc33c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/contacts.vue
// module id = 173
// module chunks = 0